import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Visible from 'coreOld/components/Visible';
import { DateInput, Label } from 'coreOld/elements';
import { Size } from 'coreOld/enums';

interface IProps {
  name?: string;
  required?: boolean;
  label?: string;
  placeholder?: string;
  timeInputLabel?: string;
  startDate?: Date;
  endDate?: Date;
  minDate?: Date;
  selected?: Date;
  selectsEnd?: boolean;
  selectsStart?: boolean;
  dateFormat?: string;
  showTimeInput?: boolean;
  size?: Size;
  showBorder?: boolean;
  hasBorder?: boolean;
  selectsRange?: boolean;
  monthsShown?: number;
  inline?: boolean;
  onChange?;
  isClearable?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
}

const DateInputView = ({
  startDate,
  endDate,
  minDate,
  onChange,
  selectsEnd,
  selectsStart,
  dateFormat,
  showTimeInput = false,
  timeInputLabel,
  label,
  required = false,
  selected,
  size,
  showBorder = false,
  hasBorder = true,
  selectsRange = false,
  monthsShown,
  inline,
  placeholder,
  isClearable = false,
  showMonthDropdown = false,
  showYearDropdown = false,
}: IProps) => {
  return (
    <>
      <Visible when={Boolean(label)}>
        <Label label={label} required={required} />
      </Visible>

      <DateInput
        size={size}
        showBorder={showBorder}
        selectsRange={selectsRange}
        hasBorder={hasBorder}
      >
        <DatePicker
          {...{
            dateFormat,
            showTimeInput,
            timeInputLabel,
            onChange,
            startDate,
            endDate,
            minDate,
            selected,
            selectsEnd,
            selectsStart,
            selectsRange,
            inline,
            monthsShown,
            isClearable,
            showMonthDropdown,
            showYearDropdown,
            placeholderText: placeholder,
          }}
        />
      </DateInput>
    </>
  );
};

export default DateInputView;
